export const EyeIcon = ({ width = '24', height = '25', fill = '#DA291C' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M12 16.8789C13.25 16.8789 14.3125 16.4414 15.1875 15.5664C16.0625 14.6914 16.5 13.6289 16.5 12.3789C16.5 11.1289 16.0625 10.0664 15.1875 9.19141C14.3125 8.31641 13.25 7.87891 12 7.87891C10.75 7.87891 9.6875 8.31641 8.8125 9.19141C7.9375 10.0664 7.5 11.1289 7.5 12.3789C7.5 13.6289 7.9375 14.6914 8.8125 15.5664C9.6875 16.4414 10.75 16.8789 12 16.8789ZM12 15.0789C11.25 15.0789 10.6125 14.8164 10.0875 14.2914C9.5625 13.7664 9.3 13.1289 9.3 12.3789C9.3 11.6289 9.5625 10.9914 10.0875 10.4664C10.6125 9.94141 11.25 9.67891 12 9.67891C12.75 9.67891 13.3875 9.94141 13.9125 10.4664C14.4375 10.9914 14.7 11.6289 14.7 12.3789C14.7 13.1289 14.4375 13.7664 13.9125 14.2914C13.3875 14.8164 12.75 15.0789 12 15.0789ZM12 19.8789C9.56667 19.8789 7.35 19.1997 5.35 17.8414C3.35 16.4831 1.9 14.6622 1 12.3789C1.9 10.0956 3.35 8.27474 5.35 6.91641C7.35 5.55807 9.56667 4.87891 12 4.87891C14.4333 4.87891 16.65 5.55807 18.65 6.91641C20.65 8.27474 22.1 10.0956 23 12.3789C22.1 14.6622 20.65 16.4831 18.65 17.8414C16.65 19.1997 14.4333 19.8789 12 19.8789ZM12 17.8789C13.8833 17.8789 15.6125 17.3831 17.1875 16.3914C18.7625 15.3997 19.9667 14.0622 20.8 12.3789C19.9667 10.6956 18.7625 9.35807 17.1875 8.36641C15.6125 7.37474 13.8833 6.87891 12 6.87891C10.1167 6.87891 8.3875 7.37474 6.8125 8.36641C5.2375 9.35807 4.03333 10.6956 3.2 12.3789C4.03333 14.0622 5.2375 15.3997 6.8125 16.3914C8.3875 17.3831 10.1167 17.8789 12 17.8789Z"
        fill={fill}
      />
    </svg>
  );
};

export const EyeCloseIcon = ({
  width = '24',
  height = '25',
  fill = '#DA291C',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      style={{ backgroundColor: '#fff' }}
    >
      <path
        d="M16.1 14.1787L14.65 12.7287C14.8 11.9454 14.575 11.212 13.975 10.5287C13.375 9.84538 12.6 9.57871 11.65 9.72871L10.2 8.27871C10.4833 8.14538 10.7708 8.04538 11.0625 7.97871C11.3542 7.91204 11.6667 7.87871 12 7.87871C13.25 7.87871 14.3125 8.31621 15.1875 9.19121C16.0625 10.0662 16.5 11.1287 16.5 12.3787C16.5 12.712 16.4667 13.0245 16.4 13.3162C16.3333 13.6079 16.2333 13.8954 16.1 14.1787ZM19.3 17.3287L17.85 15.9287C18.4833 15.4454 19.0458 14.9162 19.5375 14.3412C20.0292 13.7662 20.45 13.112 20.8 12.3787C19.9667 10.6954 18.7708 9.35788 17.2125 8.36621C15.6542 7.37454 13.9167 6.87871 12 6.87871C11.5167 6.87871 11.0417 6.91204 10.575 6.97871C10.1083 7.04538 9.65 7.14538 9.2 7.27871L7.65 5.72871C8.33333 5.44538 9.03333 5.23288 9.75 5.09121C10.4667 4.94954 11.2167 4.87871 12 4.87871C14.5167 4.87871 16.7583 5.57454 18.725 6.96621C20.6917 8.35788 22.1167 10.162 23 12.3787C22.6167 13.362 22.1125 14.2745 21.4875 15.1162C20.8625 15.9579 20.1333 16.6954 19.3 17.3287ZM19.8 23.4787L15.6 19.3287C15.0167 19.512 14.4292 19.6495 13.8375 19.7412C13.2458 19.8329 12.6333 19.8787 12 19.8787C9.48333 19.8787 7.24167 19.1829 5.275 17.7912C3.30833 16.3995 1.88333 14.5954 1 12.3787C1.35 11.4954 1.79167 10.6745 2.325 9.91621C2.85833 9.15788 3.46667 8.47871 4.15 7.87871L1.4 5.07871L2.8 3.67871L21.2 22.0787L19.8 23.4787ZM5.55 9.27871C5.06667 9.71204 4.625 10.187 4.225 10.7037C3.825 11.2204 3.48333 11.7787 3.2 12.3787C4.03333 14.062 5.22917 15.3995 6.7875 16.3912C8.34583 17.3829 10.0833 17.8787 12 17.8787C12.3333 17.8787 12.6583 17.8579 12.975 17.8162C13.2917 17.7745 13.6167 17.7287 13.95 17.6787L13.05 16.7287C12.8667 16.7787 12.6917 16.8162 12.525 16.8412C12.3583 16.8662 12.1833 16.8787 12 16.8787C10.75 16.8787 9.6875 16.4412 8.8125 15.5662C7.9375 14.6912 7.5 13.6287 7.5 12.3787C7.5 12.1954 7.5125 12.0204 7.5375 11.8537C7.5625 11.687 7.6 11.512 7.65 11.3287L5.55 9.27871Z"
        fill={fill}
      />
    </svg>
  );
};

export const Xclose = ({ width = '24', height = '25', fill = '#1F1F1F' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_6395_8550)">
        <path
          d="M19 7.28891L17.59 5.87891L12 11.4689L6.41 5.87891L5 7.28891L10.59 12.8789L5 18.4689L6.41 19.8789L12 14.2889L17.59 19.8789L19 18.4689L13.41 12.8789L19 7.28891Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_6395_8550">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.878906)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
